import Immutable from "immutable";
import moment from "moment/moment";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  soloConfirmFilesFetching: false,
  soloCastsFetching: false,
  soloConfirmFilesDidInvalidate: false,
  soloConfirmFiles: {},
  soloFilesBeingConfirmed: [],
  soloCastsInFiles: {},
  soloFilesToRecall: [],
  soloRecallingFiles: false,
  soloConfirmInstrumentNumFilter: "any",
  soloConfirmStartDateFilter: null,
  soloConfirmEndDateFilter: null
});

function handleAction(state, action) {
  switch (action.type) {
    case types.SIGN_OUT_COMPLETE:
      return initialState;
    case types.WORKAREA_SET:
      return initialState;
    case types.ORGANIZATION_SET:
      return initialState;
    case types.SOLO_CLEAR_FILTERS:
      return initialState;

    case types.SOLO_CONFIRM_FILES_INVALIDATE:
      return state.set("soloConfirmFilesDidInvalidate", true);
    case types.SOLO_CONFIRM_FILES_FETCH_REQUEST:
      return state.merge({ soloConfirmFilesFetching: true });
    case types.SOLO_CONFIRM_FILES_FETCH_SUCCESS:
      return state.merge({
        soloConfirmFilesFetching: false,
        soloConfirmFiles: action.payload.reduce(
          (R, x) => ({ ...R, [x.soloFilePk]: x }),
          {}
        )
      });
    case types.SOLO_CONFIRM_FILES_FETCH_ERROR:
      return state.merge({
        soloConfirmFilesFetching: false,
        soloConfirmFilesDidInvalidate: true
      });
    case types.SOLO_ADD_FILE_TO_CONFIRM:
      return state.update("soloFilesBeingConfirmed", x =>
        x.toSet().add(action.payload.soloFilePk)
      );
    case types.SOLO_REMOVE_FILE_TO_CONFIRM:
      return state.update("soloFilesBeingConfirmed", x =>
        x.toSet().delete(action.payload.soloFilePk)
      );
    case types.SOLO_ADD_FILE_TO_RECALL:
      return state.update("soloFilesToRecall", x =>
        x.toSet().add(action.payload.soloFilePk)
      );
    case types.SOLO_REMOVE_FILE_TO_RECALL:
      return state.update("soloFilesToRecall", x =>
        x.toSet().delete(action.payload.soloFilePk)
      );
    case types.SOLO_CONFIRM_CASTS_FETCH_REQUEST:
      return state.set("soloCastsFetching", true);
    case types.SOLO_CONFIRM_CASTS_FETCH_SUCCESS:
      return state.mergeDeep({
        soloCastsFetching: false,
        soloCastsInFiles: Immutable.fromJS(
          action.payload.reduce((R, x) => ({ ...R, [x.solo_cast_pk]: x }), {})
        ).groupBy(x => x.get("soloFilePk").toString())
      });
    case types.SOLO_CONFIRM_CASTS_FETCH_ERROR:
      return state.withMutations(s =>
        s
          .set("soloCastsFetching", false)
          .update("soloFilesBeingConfirmed", x =>
            x.toSet().delete(action.meta.soloFilePk)
          )
      );
    case types.SOLO_RECALL_FILES_REQUEST:
      return state.set("soloRecallingFiles", true);
    case types.SOLO_RECALL_FILES_SUCCESS:
      return state.withMutations(s =>
        s
          .set("soloRecallingFiles", false)
          .update("soloFilesToRecall", x =>
            x.toSet().delete(action.payload.soloFilePk)
          )
          .update("soloFilesBeingConfirmed", x =>
            x.toSet().delete(action.payload.soloFilePk)
          )
          .update("soloCastsInFiles", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
          .update("soloConfirmFiles", x =>
            x.delete(action.payload.soloFilePk.toString())
          )
      );
    case types.SOLO_RECALL_FILES_ERROR:
      return state.withMutations(s =>
        s
          .set("soloRecallingFiles", false)
          .update("soloFilesToRecall", x =>
            x.toSet().delete(action.meta.soloFilePk)
          )
      );

    case types.SET_SOLO_CONFIRM_START_DATE_FILTER:
      return state.set(
        "soloConfirmStartDateFilter",
        Immutable.fromJS(action.payload)
      );

    case types.SET_SOLO_CONFIRM_END_DATE_FILTER:
      return state.set(
        "soloConfirmEndDateFilter",
        Immutable.fromJS(action.payload)
      );
    case types.SET_SOLO_CONFIRM_INSTRUMENT_NUMBER_FILTER:
      return state.set(
        "soloConfirmInstrumentNumFilter",
        Immutable.fromJS(action.payload)
      );
    case types.UPDATE_SOLO_FILTERS: {
      let updatedState = state;
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, val] of Object.entries(action.payload)) {
        updatedState = updatedState.set(key, val);
      }
      return updatedState;
    }

    default:
      return state;
  }
}

function fieldNotNull(value) {
  if (typeof value === "undefined" || !value) {
    return false;
  }
  if (value instanceof moment || typeof value === "boolean") {
    return true;
  }
  return value !== "any";
}

export function updateUrl(state) {
  const paramObj = new URLSearchParams(window.location.search);

  const keysToExclude = ["organization", "workarea"];

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of state.entries()) {
    if (key.endsWith("Filter") && fieldNotNull(value)) {
      if (value instanceof moment) {
        paramObj.set(key, value.format("YYYY-MM-DD"));
      } else {
        paramObj.set(key, value);
      }
    } else if (!keysToExclude.includes(key)) {
      paramObj.delete(key);
    }
  }

  const newUrl = `${window.location.origin}${
    window.location.pathname
  }?${paramObj.toString()}`;
  if (newUrl !== window.location.href) {
    window.history.pushState({}, "", newUrl);
  }
}

function soloConfirmReducer(state = initialState, action) {
  const updatedState = handleAction(state, action);
  if (state !== updatedState) {
    updateUrl(updatedState);
  }
  return updatedState;
}

export default soloConfirmReducer;
